import { Flex, Skeleton } from 'front-commons/ds/components';

export function PosListPlaceholder() {
	return (
		<Flex direction="column" gap="16px">
			{Array.generate(4).map((index) => (
				<Flex key={index} gap="8px" alignItems="center">
					<Skeleton width="22px" height="22px" type="circle" />
					<Skeleton height="16px" />
				</Flex>
			))}
		</Flex>
	);
}
